/**
 * @generated SignedSource<<6d48650ba06a0d43a893f6b9bbd07979>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateNotificationIntegrationInput = {
  id: any;
  name: string;
  webhookUrl: string;
};
export type DiscordIntegrationUpdateNotificationIntegrationMutation$variables = {
  input: UpdateNotificationIntegrationInput;
};
export type DiscordIntegrationUpdateNotificationIntegrationMutation$data = {
  readonly updateNotificationIntegration: {
    readonly error: string | null | undefined;
    readonly notificationIntegration: {
      readonly id: any;
      readonly name: string;
      readonly webhookUrl: string | null | undefined;
    } | null | undefined;
  };
};
export type DiscordIntegrationUpdateNotificationIntegrationMutation = {
  response: DiscordIntegrationUpdateNotificationIntegrationMutation$data;
  variables: DiscordIntegrationUpdateNotificationIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNotificationIntegrationPayload",
    "kind": "LinkedField",
    "name": "updateNotificationIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLNotificationIntegration",
        "kind": "LinkedField",
        "name": "notificationIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webhookUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscordIntegrationUpdateNotificationIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscordIntegrationUpdateNotificationIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b30070b889109d62d6e449ec89d1611c",
    "id": null,
    "metadata": {},
    "name": "DiscordIntegrationUpdateNotificationIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DiscordIntegrationUpdateNotificationIntegrationMutation(\n  $input: UpdateNotificationIntegrationInput!\n) {\n  updateNotificationIntegration(input: $input) {\n    notificationIntegration {\n      id\n      name\n      webhookUrl\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba68beb062fea54623929296b3fca41c";

export default node;
